import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate } from 'utils/format';

export const columns = [
  {
    title: 'TransID',
    field: 'transactionId',
    Cell({ entry: { tx_ref, transactionId } }) {
      return <Link to={`/app/transactions/${tx_ref}`}>{transactionId}</Link>;
    },
  },
  { title: 'Amount', field: 'amount' },
  {
    title: 'Payment Method',
    field: 'transactionMethod',
    Cell({ entry: { transactionMethod, accountNumber } }) {
      return (
        <>
          <span>{transactionMethod}</span>
          <br />
          <span className="text-xs">{accountNumber.slice(0, 7)}***</span>
        </>
      );
    },
  },
  {
    title: 'Status',
    field: 'status',
    Cell({ entry: { status } }) {
      let activeColor;

      // Determine the color based on the status
      switch (status) {
        case 'pending':
          activeColor = 'orange';
          break;
        case 'successful':
          activeColor = 'green';
          break;
        case 'failed':
          activeColor = 'red';
          break;
        default:
          activeColor = 'gray'; // Default color for unknown status
      }

      return (
        <p>
          <div
            className={`rounded-full p-1 px-2 text-xs bg-${activeColor}-100 text-center text-${activeColor}-500`}
          >
            {status}
          </div>
        </p>
      );
    },
  },
  {
    title: 'Activity',
    field: '',
    Cell({ entry: { transactionType } }) {
      return (
        <p className="text-sm">
          {transactionType === 'Withdraw' && 'Withdrawing from wallet'}
          {transactionType === 'Pending' && 'Withdrawing from wallet'}
          {transactionType === 'Successful' && 'Withdrawing from wallet'}
        </p>
      );
    },
  },
  { title: 'People', field: 'firstName' },
  {
    title: 'Date',
    field: 'createdAt',
    Cell({ entry: { createdAt } }) {
      return <p>{formatDate(createdAt)}</p>;
    },
  },
];
